import React from 'react';

import AddMemberToFavourite from '@components/assign-team-member/AddMemberToFavourite';
import { BackButton } from '@components/buttons/BackButton';

import { isMyFavourite } from '@features/favourites/utils/favouriteUtil';

const FavouriteDetailsTopHeader = ({ onEditFolder, folderInfo, children, folderId }) => {
	return (
		<div className="top-header collection-topbar">
			{/* Filter Contanier top */}
			<div className="container-fluid pt-3 pl-0">
				<div className="row">
					<div className="col-md-8">
						<div className="collection-overview d-flex align-items-center">
							<BackButton />
							<h1 className="semibold-14 m-0 ml-2">{folderInfo?.name}</h1>
							{folderInfo?.brandResponse?.name && (
								<div className="collection-status pl-3 mr-2">
									<span className="brand-common-design">
										{folderInfo?.brandResponse?.name}
									</span>
								</div>
							)}

							{!isMyFavourite(folderId) && (
								<div className="ml-3">
									<span
										className="regular-14 primary_bright_01 cursor-pointer"
										onClick={() =>
											onEditFolder({
												name: folderInfo?.name,
												id: folderInfo?.id,
												brandResponse: folderInfo?.brandResponse
											})
										}
									>
										Edit
									</span>
								</div>
							)}
						</div>
					</div>
					<div className="col-md-4">
						{!isMyFavourite(folderId) && (
							<AddMemberToFavourite
								folderId={folderInfo?.id || null}
								memberList={folderInfo?.members}
							/>
						)}
					</div>
				</div>
			</div>
			{children}
		</div>
	);
};

export default FavouriteDetailsTopHeader;
